import { render, staticRenderFns } from "./RecipientsPanel.vue?vue&type=template&id=261d8e41&scoped=true&lang=pug"
import script from "./RecipientsPanel.vue?vue&type=script&lang=js"
export * from "./RecipientsPanel.vue?vue&type=script&lang=js"
import style0 from "./RecipientsPanel.vue?vue&type=style&index=0&id=261d8e41&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261d8e41",
  null
  
)

export default component.exports